import request from "@/utils/request"
export function setStatisticList(type, is_source) {
    let params = {
        type, is_source
    }
    request({
        url: '/carnival/setStatistic',
        method: 'post',
        data: params
    })
} 